import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GenericDocSerialNumberSwapRequestContainerModel } from "../../../../../../models/aggregates/generic_doc";
import { ApiResponseModel, ApiVisa, BasicApiResponseModel } from "../../shared";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";

@Injectable({ providedIn: "root" })
export class GenericDocSerialNumberSwapRequestService extends BaseApiTemplateService<GenericDocSerialNumberSwapRequestContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'serial-number-swap-request/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX  + Core2Config.GENERIC_PREFIX + 'serial-number-swap-request/backoffice-ep';
    this.httpClient = http;
  }

  repost(genDocHdrGuid: any, swapRequestGuid: any, visa: ApiVisa): Observable<ApiResponseModel<GenericDocSerialNumberSwapRequestContainerModel>> {
    const endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX  + Core2Config.GENERIC_PREFIX + 'serial-number-swap-request/backoffice-ep/repost';
    let apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'serial-number-swap-request/backoffice-ep/repost';
    if (endpoint_path && visa.api_domain_url) {
      apiUrl = `${visa.api_domain_url}${endpoint_path}/${genDocHdrGuid}/${swapRequestGuid}`;
    }
    return this.httpClient.post<ApiResponseModel<GenericDocSerialNumberSwapRequestContainerModel>>(
      apiUrl,
      {},
      this.getHttpHeader(visa)
    );
  }
}
